import React, { useState } from 'react';
import { Clock } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const DAY_OPTIONS = [1, 2, 3, 7, 14];

function formatDueDate(isoDate) {
  if (!isoDate) return '';
  try {
    return new Date(isoDate).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '';
  }
}

export default function BuyLaterButton({ product, onSetDays, onRemove, disabled, className }) {
  const [open, setOpen] = useState(false);
  const isActive = product.buy_later === true;
  const dueLabel = formatDueDate(product.buy_later_at);

  const defaultClassName = `p-1.5 hover:bg-gray-100 border-r text-gray-600 disabled:opacity-50 ${
    isActive ? 'bg-orange-50 text-orange-600' : ''
  }`;

  const handleSelectDays = (days) => {
    onSetDays(days);
    setOpen(false);
  };

  const handleRemove = () => {
    onRemove();
    setOpen(false);
  };

  return (
    <>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(true)}
        className={className || defaultClassName}
        title={
          isActive
            ? `Купить позже (${dueLabel || 'дата не задана'})`
            : 'Купить позже — напомнить через несколько дней'
        }
      >
        <Clock className="w-4 h-4" />
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Купить позже</DialogTitle>
            <DialogDescription className="text-left pt-1">
              {product.name}
              {product.articul ? ` · ${product.articul}` : ''}
            </DialogDescription>
          </DialogHeader>

          {isActive ? (
            <div className="space-y-4">
              <p className="text-sm text-gray-700">
                Напомнить: <span className="font-semibold">{dueLabel || '—'}</span>
              </p>
              <p className="text-sm text-gray-500">Изменить срок или убрать из отлежки:</p>
              <div className="grid grid-cols-3 gap-2">
                {DAY_OPTIONS.map((days) => (
                  <Button
                    key={days}
                    variant="outline"
                    onClick={() => handleSelectDays(days)}
                  >
                    {days} {days === 1 ? 'день' : days < 5 ? 'дня' : 'дней'}
                  </Button>
                ))}
              </div>
              <Button
                variant="ghost"
                className="w-full text-red-600 hover:text-red-700 hover:bg-red-50"
                onClick={handleRemove}
              >
                Убрать из отлежки
              </Button>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-sm text-gray-600">Напомнить купить у поставщика через:</p>
              <div className="grid grid-cols-3 gap-2">
                {DAY_OPTIONS.map((days) => (
                  <Button
                    key={days}
                    variant="outline"
                    onClick={() => handleSelectDays(days)}
                  >
                    {days} {days === 1 ? 'день' : days < 5 ? 'дня' : 'дней'}
                  </Button>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
